import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import s from "./HivSelfFoundedTreatment.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getRussiaHiVMigrantsDetails,
  getRussiaHiVMigrantsTreatmentDetails,
} from "../../redux/InformationSlice";
import { useParams } from "react-router-dom";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import InCountry from "../../Components/InCountry/InCountry";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { Seo } from "../../Seo";

const HivSelfFoundedTreatment = () => {
  const data = useSelector(
    (state: RootState) => state.info.russiaHiVMigrantsTreatmentDetails,
  );

  const params = useParams();
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(getRussiaHiVMigrantsTreatmentDetails(Number(params.id)));
  }, [params]);
  const { width } = useWindowDimensions();
  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Seo
        title="Платное лечение ВИЧ в России"
        description="Лечение ВИЧ в частных клиниках РФ за свой счет. Узнайте стоимость лечения и как найти врача, чтобы получить помощь НКО."
        url="https://www.vputi.org/russia/hiv/migrants/treatment/self-founded/1"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство России / ВИЧ / Информация для мигрантов с ВИЧ / Как получать лечение / Получать лечение за свой счёт",
            path: "/russia/hiv/migrants/treatment/2",
          }}
        />

        <ContactButtons />
        <div className={s.text}>
          <div className={s.title}>{data?.title_1}</div>
          <div
            className={s.body}
            dangerouslySetInnerHTML={{ __html: data?.body_1 ?? "" }}
          ></div>
          {
            <div className={s.yellow_wrapper}>
              <div
                className={s.body}
                dangerouslySetInnerHTML={{ __html: data?.body_2 ?? "" }}
              ></div>
            </div>
          }
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default HivSelfFoundedTreatment;
